<template>
    <div>
    <p>Both EXE and MSI installers are executable programs and both are bundled with Java Runtime. You don't need to download anything else.
    </p>
      <p>We recommend using the EXE installer, however, system administrators may want to choose the MSI installer to automate bulk installation job.</p>

    <div class="p-3">
        <strong>GanttProject {{ version }} for Windows</strong>
        <div class="help-text pb-3">Built on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/win/exe`" v-on:click="onDownloadStarted" data-track-event="dwnl,dwnl-gp33-exe">Download EXE installer [{{ sizeExe }}]</a>
        <br><br>
        <ul>
          <li>GanttProject {{ version }} will be installed side by side with the previous version, if any.</li>
<!--          <li>The result of antivirus tests: <a :href="`https://www.virustotal.com/gui/file/${virustotalHashExe}/detection`">1 engine out of 58 suspects </a></li>-->
          <li>The MD5 sum of the installer file: <code>{{ md5sumExe }}</code></li>
        </ul>
        <br>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/win/msi`" v-on:click="onDownloadStarted" data-track-event="dwnl,dwnl-gp33-msi">Download MSI installer [{{ sizeMsi }}]</a>
        <br><br>
        <ul>
          <li>GanttProject {{ version }} will be installed side by side with the previous version, if any.</li>
          <li>There is a <a href="https://www.silentinstall.org/msiexec/">silent install option</a> for system administrators
            who need to perform bulk installations on user computers.</li>
          <li>The result of antivirus tests: <a :href="`https://www.virustotal.com/gui/file/${virustotalHashMsi}/detection`">no viruses detected by VirusTotal</a></li>
          <li>The MD5 sum of the installer file: <code>{{ md5sumMsi }}</code></li>
        </ul>
    </div>

      <h3>Maintenance updates</h3>
      <p>Maintenance updates to version {{ version }} will be delivered via our Update Channel.
        Please leave Auto-Update option in the settings switched on to let GanttProject to check for updates from time to time.
        When a new update becomes available, you will be able to review it and choose to install or skip.</p>

    <h3>Possible reports from anti-virus software</h3>

    <p>Some anti-virus programs may report viruses in the installer. This is a known issue which happens
        to installers very often. It doesn't mean that the file is infected, it rather means that
      an antivirus engine have seen malware which was packed using a similar installer.</p>

    <p>Both installers were checked by VirusTotal and at the moment of writing this only 1 out of dozens engines reported positive results (which is good).</p>

    <p>If your anti-virus software reports positive result, this is most likely a false positive,
        provided that the file which you downloaded is the original one. You can check if you downloaded
        the original file by <a href="https://md5file.com/calculator">checking its MD5 checksum</a>.
    </p>

    <p>If you can't or don't want to run program which your antivirus engine considers as infected,
        try using <a href="#zip">platform-independent ZIP archive</a>.
        This distribution includes no native code and doesn't require
        Administrator privileges, however, it requires Java 17 Runtime to be installed.</p>
    </div>
</template>

<script>
import {gaSendEvent} from "@/components/Analytics";

    export default {
        name: "DownloadWin33",
        props: {
          version: String,
          releaseDate: String,
          sizeMsi: String,
          md5sumMsi: String,
          virustotalHashMsi: String,
          sizeExe: String,
          md5sumExe: String,
          virustotalHashExe: String
        },
      methods: {
        onDownloadStarted: function() {
          gaSendEvent('download_started');
        }
      }
    }
</script>

<style scoped>

</style>
